import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, DialogTitle, IconButton, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup";
import { UserAuth } from "../../context/AuthContext";
import TokenContext from "../../context/TokenContext";
import CustomSearchSelect from "../CustomSearchSelect";
import CustomTextField from "../CustomTextField";
import {tipoNovedadPago } from "../../Redux/novedadesLiquidacion";
import { obtenerDvisas } from "../../Redux/autocompletados";
import CustomDateField from "../CustomDateField";

const opcionesInformaNovedadesPago = [
  { value: "100000000", label: "Puesto en el Ranking" },
  { value: "100000001", label: "Porcentaje" },
  { value: "100000002", label: "Cantidad de Horas" },
  { value: "100000003", label: "Cantidad" },
  { value: "100000004", label: "Importe" },
];

const ModalAprobacionRechazoPago = ({ open, handleClose, liquidacion, onSubmit }) => {
  const token = useContext(TokenContext);
  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { empleado } = UserAuth();

  const [tipoNovedadP, setTipoNovedadP] = useState([]);
  const [divisas, setDivisas] = useState([]);

  const [validacionSchema, setValidacionSchema] = useState(null);

  const [aprobacion, setAprobacion] = useState("");

  const loadAprobarRechazarLiquidacionSelector = useSelector(
    (store) => store.novedadesLiquidacion.loadAprobarRechazarLiquidacion
  );
  const tipoNovedadPSelector = useSelector(
    (store) => store.novedadesLiquidacion.tipoNovedadPago
  );
  const divisasSelector = useSelector((store) => store.autocompletados.divisas);

  useEffect(() => {
    if (tipoNovedadPSelector.length > 0) {
      var array = [];
      tipoNovedadPSelector.forEach((tipo) => {
        var objeto = {
          label: tipo.new_name,
          value: tipo.new_tipodenovedaddepagoid,
        };
        array.push(objeto);
      });
      setTipoNovedadP(array);
    }
  }, [tipoNovedadPSelector]);

  useEffect(() => {
    if (divisasSelector.length > 0) {
      var array = [];
      divisasSelector.forEach((tipo) => {
        var objeto = {
          label: tipo.currencyname,
          value: tipo.new_tipodenovedaddepagoid,
        };
        array.push(objeto);
      });
      setDivisas(array);
    }
  }, [divisasSelector]);

  const defaultValues = {
    id: null,
    fechaNovedad: null,
    empleado: null,
    tipoNovedadPagoSelect: null,
    tipoNovedadSelect: null,
    divisa: null,
    aprobar: null,
    fechaAprobacion: null,
    motivoDelRechazo: null,
  };

  const validacionSchemaAprobacion = yup.object().shape({
    fechaNovedad: yup.date().nullable().typeError("Por favor indica una fecha válida de Novedad").required("Por favor indica la fecha de Novedad"),
    empleado: yup.string().required("Required"),
    tipoNovedadPagoSelect: yup.object({ value: yup.string().required("Por favor seleccione el tipo de novedad") }),
    fechaAprobacion: yup.date().nullable().typeError("Por favor indica una fecha válida de aprobación").required("Por favor indica la fecha de aprobación"),
  });

  const validacionSchemaRechazo = yup.object().shape({
    fechaNovedad: yup.date().nullable().typeError("Por favor indica una fecha válida de Novedad").required("Por favor indica la fecha de Novedad"),
    empleado: yup.string().required("Required"),
    tipoNovedadPagoSelect: yup.object({ value: yup.string().required("Por favor seleccione el tipo de novedad") }),
    motivoDelRechazo: yup.string().required("Required"),
  });

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  });

  const { handleSubmit, reset, watch, setValue } = methods;

  useEffect(() => {
    if (aprobacion == 100000000) {
      setValidacionSchema(validacionSchemaAprobacion);
    } 
    if (aprobacion == 100000001) {
      setValidacionSchema(validacionSchemaRechazo);
    }
    setValue("aprobar", aprobacion);
  }, [aprobacion, setValue]);

  useEffect(() => {
    reset(liquidacion);
    dispatch(tipoNovedadPago(token));
    dispatch(obtenerDvisas(token));
  }, [liquidacion, reset]);

  const submitDatos = (datos) => {
    onSubmit(datos)
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomDateField
                name="fechaNovedad"
                label="Fecha de Novedad:"
                rules={{ required: "Required!" }}
                helperText="Por favor indica la fecha de Novedad"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                readOnly={true}
                name="empleado"
                label="Empleado"
                rules={{ required: "Required!" }}
                helperText="Por favor indica el Empleado."
                req={true}
                disabled
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={tipoNovedadP}
                type="text"
                name="tipoNovedadPagoSelect"
                lab="Tipo de Novedad de Pago"
                disabled
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesInformaNovedadesPago}
                type="text"
                name="tipoNovedadSelect"
                lab="Informa"
                disabled
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="cantidadHoras"
                label="Cantidad Horas"
                defaultValue={liquidacion.cantidadHoras}
                rules={{ required: "Required!" }}
                helperText="Por favor indica la cantidad de horas."
                req={true}
                disabled
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={divisas}
                type="text"
                name="divisa"
                lab="Divisa"
                disabled
              />
            </Grid>
            {liquidacion.aprobadorId == empleado.empleadoid && (
              <>
                <Typography variant="h5" color="inherit" sx={{ my: 2 }}>
                  Aprobación
                </Typography>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                      ¿Que acción desea realizar?
                    </Typography>
                    <Box
                      sx={{
                        minWidth: "100%",
                        display: "flex",
                        flexDirection:"column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion("100000000")}
                        disabled={aprobacion === "100000000"}
                        color="success"
                      >
                        Aceptar
                      </Button>
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion("100000001")}
                        disabled={aprobacion === "100000001"}
                        color="error"
                      >
                        Rechazar
                      </Button>
                    </Box>
                  </Box>
                </Grid>
                {aprobacion == 100000000 && (
                  <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
                    <CustomDateField
                      name="fechaAprobacion"
                      label="Fecha de aprobación:"
                      rules={{ required: "Required!" }}
                      helperText="Por favor indica la fecha de aprobación"
                      req={true}
                      className="custom-helper"
                    />
                  </Grid>
                )}
                {aprobacion == 100000001 && (
                  <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                    <CustomTextField
                      Component={TextField}
                      name="motivoDelRechazo"
                      label="Motivo del rechazo"
                      rows={3}
                      multiline={true}
                      rules={{ required: "Required!" }}
                      helperText="Por favor indica el motivo del rechazo."
                      req={true}
                    />
                  </Grid>
                )}
              </>
            )}
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={loadAprobarRechazarLiquidacionSelector === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ModalAprobacionRechazoPago;
